import 'uni-pages';
import Vue from 'vue'
import Page from './demo/pages/mall/orderPay.vue'
createPage(Page)